/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { FullscreenDialog } from '@coursera/cds-core';

import { PdfPageSelectUI } from 'bundles/cml/editor/components/elements/asset/PdfPageSelectUI';

const { Header, Content } = FullscreenDialog;

const styles = {
  contentContainer: css`
    padding: 0;
  `,
};

type Props = {
  embedStartPage?: number;
  embedEndPage?: number;
  onClose: () => void;
  onPageSelect: (pageStart?: number, pageEnd?: number) => void;
  url: string;
  assetId: string;
};

export const PdfPageSelectModal = ({ embedStartPage, embedEndPage, onPageSelect, onClose, url, assetId }: Props) => {
  return (
    <FullscreenDialog
      className="rc-CMLEditorMenu" // class is needed to prevent CML editor blur rules from applying
      open={true}
      onClose={onClose}
      aria-describedby="embedPdfContent"
      contentWidth="100%"
      sticky="none"
    >
      <Header />
      <Content css={styles.contentContainer} id="embedPdfContent">
        <PdfPageSelectUI
          embedStartPage={embedStartPage}
          embedEndPage={embedEndPage}
          onClose={onClose}
          onPageSelect={onPageSelect}
          url={url}
          assetId={assetId}
        />
      </Content>
    </FullscreenDialog>
  );
};
